<mat-icon class="icons">
    {{ toggleIcons.icon_left }}
</mat-icon>

<mat-slide-toggle color="accent" (toggleChange)="emitToggleStatus()" class="toggle">
</mat-slide-toggle>

<mat-icon class="icons">
    {{ toggleIcons.icon_right }}
</mat-icon>